import { Option } from './option'
import { Component, forwardRef, Input, ViewChild, ViewEncapsulation } from '@angular/core'
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS,
  Validator,
  AbstractControl,
  ValidationErrors
} from '@angular/forms'
import { NgSelectComponent } from '@ng-select/ng-select'

@Component({
  selector: 'app-select',
  templateUrl: './app-select.component.html',
  styleUrls: ['./app-select.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppSelectComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => AppSelectComponent),
      multi: true
    }
  ],
  standalone: false
})
export class AppSelectComponent implements ControlValueAccessor, Validator {
  @ViewChild(NgSelectComponent, { static: true }) ref: NgSelectComponent
  @Input() required: boolean = null
  @Input() id: string
  @Input() name: string
  @Input() allowClear = false
  @Input() selected: (value: any) => void
  @Input() removed: () => void
  @Input() placeholder: string
  @Input() ngClass: string
  @Input() multiple: boolean
  @Input() filterInactive: boolean
  @Input() disabled: boolean
  @Input() appendTo: string = null

  private filteredItems: Option[]
  public activeIds: any

  private _items: Option[]

  private activeFilter = (option: Option) => {
    let isSelected = false
    if (!!this.activeIds) {
      isSelected =
        this.activeIds === option.id ||
        (Array.isArray(this.activeIds) && this.activeIds.find(id => id === option.id))
    }
    return isSelected || option.value.IsActive || option.value.Enabled
  }

  private filterItems() {
    if (this._items && this.filterInactive) {
      this.filteredItems = this._items.filter(this.activeFilter)
    } else {
      this.filteredItems = this._items
    }
  }

  @Input() public set items(itemsInput: Option[] | string[]) {
    let selectItems: Option[] = []
    if (itemsInput?.length > 0) {
      selectItems =
        typeof itemsInput[0] === 'string'
          ? (itemsInput as string[]).map(s => new Option(s, s, s))
          : (itemsInput as Option[])
    }
    this._items = selectItems
    this.filterItems()
  }

  public get active() {
    return this.ref.selectedItems as Option[]
  }

  public getFilteredItems() {
    return this.filteredItems
  }

  @Input() public set active(val: any) {
    if (!val || val.length === 0) {
      this.activeIds = []
    } else if (!this.multiple) {
      this.activeIds = !!val[0].id ? val[0].id : val[0]
    } else {
      this.activeIds = !!val[0].id ? val.map((_: any) => _.id) : val
    }
    this.filterItems()
  }

  validate(_control: AbstractControl): ValidationErrors {
    return this.required && this.ref.selectedItems.length === 0
      ? { required: { valid: false } }
      : null
  }
  writeValue(obj: any): void {
    this.ref.writeValue(obj)
  }
  registerOnChange(fn: any): void {
    this.ref.registerOnChange(fn)
  }
  registerOnTouched(fn: any): void {
    this.ref.registerOnTouched(fn)
  }
}
